module.exports = "<!-- This is template for panel tools -->\r\n<!-- It contains collapse function (showhide) and close function (closebox) -->\r\n<!-- All function is handled from directive panelTools in directives.js file -->\r\n<div class=\"panel-tools\">\r\n    <a ng-click=\"showhide()\"><i class=\"fa-thin fa-chevron-up\"></i></a>\r\n    <a ng-click=\"fullscreen()\"><i class=\"fa-thin fa-expand\"></i></a>\r\n    <a ng-click=\"closebox()\"><i class=\"fa-thin fa-times\"></i></a>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/directives/panelTools/panelToolsFullscreen.html
// module id = 355
// module chunks = 0